module.exports = __webpack_public_path__ + "img/vd-love-potion.e1a1ce9f.svg";